import { atom } from 'jotai';
import type { ReviewOutputDataT } from '../types';
import { completedAnnotationsAtom } from './annotation-review-atoms';
import { commentsAtom } from './feedback-atoms';
export const reviewOutputAtom = atom<ReviewOutputDataT>(get => {
  const completedAnnotations = get(completedAnnotationsAtom);
  const comments = get(commentsAtom);
  return {
    annotations: completedAnnotations,
    comments
  };
});